import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../utils/api";

export default function HistoriqueModal({ open, handleClose, user }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && user && user.ID_User) {
      fetchUserHistory(user.ID_User);
    }
  }, [open, user]);

  const fetchUserHistory = async (userId) => {
    setLoading(true);
    try {
      // Assuming there's an API endpoint for user history
      const response = await api.get(`/users/${userId}/history`);
      setHistory(response.data || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching user history:', err);
      setError('Failed to load user history. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 400, mr: 3, textTransform:'uppercase' }}>
          Historique des actions - {user?.name} {user?.prenom}
        </Typography>
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
            <CircularProgress color="error" />
            <Typography variant="body2" sx={{ ml: 2 }}>Chargement de l'historique...</Typography>
          </div>
        ) : error ? (
          <Typography color="error" sx={{ textAlign: 'center', py: 3 }}>{error}</Typography>
        ) : history.length === 0 ? (
          <Typography variant="subtitle2" sx={{ fontSize: '17px', textAlign:'center', py: 3 }}>
            Aucun résultat n'a été trouvé
          </Typography>
        ) : (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Détails</TableCell>
                  <TableCell>Utilisateur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{new Date(item.created_at).toLocaleString()}</TableCell>
                    <TableCell>{item.action}</TableCell>
                    <TableCell>{item.details}</TableCell>
                    <TableCell>{item.performed_by}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <Divider sx={{mb: 1}}/>
      <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="outlined" 
          sx={{ 
            color: "red", 
            borderColor: "red", 
            textTransform: "none", 
            "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } 
          }} 
          onClick={handleClose}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
